import { normalizeApiError, ykApiClient } from './apiClient';

function normalizeList(raw) {
  if (Array.isArray(raw)) return raw;
  if (!raw) return [];

  const candidate =
    raw?.data ??
    raw?.result ??
    raw?.response ??
    raw?.items ??
    raw?.$values ??
    raw;

  if (Array.isArray(candidate)) return candidate;
  if (Array.isArray(candidate?.$values)) return candidate.$values;
  return [];
}

export async function getCountries() {
  try {
    let res;
    try {
      res = await ykApiClient.get('/ykrestapi/CommonChannel/GetCountries');
    } catch {
      res = await ykApiClient.get('/ykrestapi/CommonChannel/GetCountry');
    }

    const list = normalizeList(res?.data);

    return (Array.isArray(list) ? list : []).map((c) => ({
      id:
        c?.country_Id ??
        c?.countryId ??
        c?.country_id ??
        c?.id ??
        c?.value ??
        null,
      name:
        c?.country_Name ??
        c?.countryName ??
        c?.country_name ??
        c?.name ??
        c?.label ??
        '',
      raw: c,
    }));
  } catch (e) {
    throw normalizeApiError(e);
  }
}

export async function getStatesByCountry({ countryId }) {
  try {
    const cid = Number(countryId);
    let res;
    try {
      res = await ykApiClient.get('/ykrestapi/CommonChannel/GetStatesByCountry', {
        params: {
          countryId: cid,
        },
      });
    } catch {
      res = await ykApiClient.post('/ykrestapi/CommonChannel/GetState', {
        countryId: cid,
        country_Id: cid,
        country_id: cid,
        id: cid,
      });
    }

    const list = normalizeList(res?.data);

    return (Array.isArray(list) ? list : []).map((s) => ({
      id: s?.state_Id ?? s?.stateId ?? s?.state_id ?? s?.id ?? s?.value ?? null,
      name: s?.state_Name ?? s?.stateName ?? s?.state_name ?? s?.name ?? s?.label ?? '',
      raw: s,
    }));
  } catch (e) {
    throw normalizeApiError(e);
  }
}
